<template>
  <button class="upload-button" v-b-tooltip.hover :title="title">
    <i class="fa fa-upload upload-icon"></i>
  </button>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {};
  },
};
</script>

<style>
.upload-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgb(86, 100, 210) !important;
}
.upload-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
}
.upload-button:hover .upload-icon {
  transform: scale(1.3);
}
.upload-button:hover {
  background-color: rgba(86, 100, 210, 0.1);
}
</style>
